import { Message } from 'dg-web-shared/lib/Localized.ts';
import { ParkingaboCustomerPaymentMode } from './ParkingaboOperatingMode.tsx';

export const enum CustomerTenantState {
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED',
    LOCKED = 'LOCKED',
    TERMINATED = 'TERMINATED',
}

export function getTranslationOfCustomerState(
    state: CustomerTenantState | null | undefined,
    onboardingCompleteTime: string | null | undefined,
    paymentMode: ParkingaboCustomerPaymentMode | undefined,
): Message {
    switch (state) {
        case CustomerTenantState.ACTIVE:
            if (
                onboardingCompleteTime ||
                paymentMode !== ParkingaboCustomerPaymentMode.APP_PAYMENT
            ) {
                return {
                    de: 'AKTIV',
                    fr: 'ACTIF',
                    it: 'ATTIVO',
                    en: 'ACTIVE',
                };
            }
            return {
                de: 'PENDENT',
                fr: 'EN ATTENTE',
                it: 'IN ATTESA',
                en: 'PENDING',
            };
        case CustomerTenantState.ARCHIVED:
            return {
                de: 'ARCHIVIERT',
                fr: 'ARCHIVÉ',
                it: 'ARCHIVIATO',
                en: 'ARCHIVED',
            };
        case CustomerTenantState.LOCKED:
            return {
                de: 'GESPERRT',
                fr: 'VERROUILLÉ',
                it: 'BLOCCATO',
                en: 'LOCKED',
            };
        case CustomerTenantState.TERMINATED:
            return {
                de: 'GELÖSCHT',
                fr: 'SUPPRIMÉ',
                it: 'ELIMINATO',
                en: 'DELETED',
            };
        case null:
        case undefined:
            return {
                de: '',
                fr: '',
                it: '',
                en: '',
            };
    }
}
